var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"modal-header\">\n<h3 class=\"modal-title\" translate>Huolto käynnissä</h3>\n</div>\n<div class=\"modal-body\">\n<p translate>\n<strong>Oral.fi on väliaikaisesti huoltotilassa.</strong> Kaikki sivuston toiminnot eivät ole käytettävissä. Pahoittelemme mahdollista haittaa.\n</p>\n<p translate>\nAsiakaspalvelu palvelee numerosta <a class=\"link-no-style\" href=\"tel:+358104003400\"><strong>010 400 3400</strong></a> <small>ma-pe 8.00-17.00</small>\n</p>\n<div class=\"maintenance-notes\" ng-if=\"$ctrl.note\">\n<hr/>\n{{ ::$ctrl.note }}\n</div>\n</div>\n<div class=\"modal-footer\">\n<normal-button click-action=\"$ctrl.close()\"><span translate>Jatka</span></normal-button>\n</div>\n</div>\n";
var id1="app/common/keepalive/maintenance.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/keepalive/maintenance.tpl.html
// module id = 374
// module chunks = 6